import Main from './Main'
import Lista from './components/UnidadePolicial'
import Novo from './components/NovoUnidadePolicial'

export default [
  {
    path: 'unidade-policial',
    name: 'config.unidade-policial',
    component: Main,
    redirect: { name: 'policiacivil.policia.unidade-policial.list' },
    children: [
      {
        path: '/',
        name: 'policiacivil.policia.unidade-policial.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'policiacivil.policia.unidade-policial.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'policiacivil.policia.unidade-policial.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/policiais/unidade-policial/routes.js